/**
 * Code Analysis - 호버 정보 API
 */
import { langServerClient } from '@/shared/api/langserver/client';

import type { ModuleTarget } from '@/entities/langserver/api/types';

import type { AnalysisRequest, HoverInfo } from './types';

export const fetchHover = async (target: ModuleTarget = 'run', payload: AnalysisRequest): Promise<HoverInfo> => {
  try {
    const response = await langServerClient.post<HoverInfo>(`/${target}/api/v1/analysis/template/hover`, payload);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch hover info:', error);
    return null;
  }
};
